(function () {
  'use strict';

  if (window.__cartDrawerUpgradeBound) return;
  window.__cartDrawerUpgradeBound = true;

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cartJsUrl() {
    const base = (typeof window.routes !== 'undefined' && window.routes.cart_url) || '/cart';
    return base.endsWith('.js') ? base : base + '.js';
  }

  async function fetchCart() {
    const r = await fetch(cartJsUrl(), { headers: { Accept: 'application/json' } });
    return r.json();
  }

  function withJsonSuffix(url) {
    if (!url) return url;
    return url.endsWith('.js') ? url : url + '.js';
  }

  function cartAddUrl() {
    if (typeof window.routes !== 'undefined' && window.routes.cart_add_url) {
      return withJsonSuffix(window.routes.cart_add_url);
    }
    const root = rootPath().replace(/\/?$/, '/');
    return (root === '/' ? '' : root) + 'cart/add.js';
  }

  function cartChangeUrl() {
    if (typeof window.routes !== 'undefined' && window.routes.cart_change_url) {
      return withJsonSuffix(window.routes.cart_change_url);
    }
    const root = rootPath().replace(/\/?$/, '/');
    return (root === '/' ? '' : root) + 'cart/change.js';
  }

  function resolveSourceLine(cart, domKey, variantId) {
    const items = cart.items || [];
    let line = items.find((i) => i.key === domKey);
    if (!line && variantId) {
      const vid = String(variantId);
      line = items.find((i) => String(i.variant_id) === vid);
    }
    return line ? { key: line.key, line } : null;
  }

  function keyForVariant(cart, variantId) {
    if (!variantId) return null;
    const vid = String(variantId);
    const line = (cart.items || []).find((i) => String(i.variant_id) === vid);
    return line ? line.key : null;
  }

  function errMsg() {
    if (typeof window.cartStrings !== 'undefined' && window.cartStrings.upgrade_error) {
      return window.cartStrings.upgrade_error;
    }
    return 'There was an error updating your cart. Please try again.';
  }

  function cartError(data, stage) {
    const err = new Error((data && (data.description || data.message)) || stage);
    err.stage = stage;
    err.response = data;
    return err;
  }

  /**
   * The same four sections Dawn's own quantity path requests (assets/cart.js:84-107),
   * written into the same selectors. Section ids for template-owned sections come from
   * the runtime dataset.id; the JSON template key ("cart-items") is not a valid section id.
   *
   * @see https://shopify.dev/docs/api/ajax/reference/cart#bundled-section-rendering
   */
  function sectionsToRender() {
    return [
      { id: 'main-cart-items', selector: '.js-contents' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' },
      { id: 'main-cart-footer', selector: '.js-contents' },
    ]
      .map((entry) => {
        const element = document.getElementById(entry.id);
        if (!element) return null;
        const section = entry.section || element.dataset.id;
        if (!section) return null;
        return { ...entry, element, section };
      })
      .filter(Boolean);
  }

  function sectionInnerHTML(html, selector) {
    if (!html) return null;
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function renderSections(parsedState) {
    if (!parsedState || !parsedState.sections) return;
    sectionsToRender().forEach((entry) => {
      const inner = sectionInnerHTML(parsedState.sections[entry.section], entry.selector);
      if (inner === null) {
        console.error('[cart-drawer-upgrade] section did not render:', entry.section);
        return;
      }
      const target = entry.element.querySelector(entry.selector) || entry.element;
      target.innerHTML = inner;
    });
  }

  function showOverlay(contents) {
    if (!contents) return null;
    contents.style.position = 'relative';
    const overlay = document.createElement('div');
    overlay.className = 'cart-drawer-upgrade-overlay';
    overlay.setAttribute('role', 'presentation');
    overlay.innerHTML = '<div class="cart-drawer-upgrade-spinner" aria-hidden="true"></div>';
    contents.appendChild(overlay);
    return overlay;
  }

  function removeOverlay(contents, overlay) {
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    if (contents) contents.style.position = '';
  }

  document.body.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-cart-drawer-upgrade-cta]');
    if (!btn) return;

    e.preventDefault();
    const domSourceKey = btn.getAttribute('data-source-line-key');
    const sourceVariantId = btn.getAttribute('data-source-variant-id');
    const variantId = btn.getAttribute('data-target-variant-id');
    const planId = btn.getAttribute('data-target-selling-plan-id');
    const qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;

    if (!domSourceKey || !variantId || !planId) return;

    const contents = document.querySelector('#CartDrawer-CartItems') || document.querySelector('.cart__contents');
    const overlay = showOverlay(contents);
    btn.disabled = true;

    try {
      const cartBefore = await fetchCart();
      const resolved = resolveSourceLine(cartBefore, domSourceKey, sourceVariantId);
      if (!resolved) {
        throw new Error('stale_line');
      }
      const sourceKey = resolved.key;

      const addRes = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: qty, selling_plan: Number(planId) }],
        }),
      });
      const addData = await addRes.json();
      if (!addRes.ok) {
        throw cartError(addData, 'add');
      }

      const cartAfterAdd = await fetchCart();
      const keyToRemove = keyForVariant(cartAfterAdd, sourceVariantId) || sourceKey;
      if (!keyToRemove) {
        throw new Error('missing_line_after_add');
      }

      const changeBody = { id: keyToRemove, quantity: 0 };
      const sections = sectionsToRender().map((entry) => entry.section);
      if (sections.length) {
        changeBody.sections = sections;
        changeBody.sections_url = window.location.pathname;
      }

      const chRes = await fetch(cartChangeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(changeBody),
      });
      const chData = await chRes.json();
      if (!chRes.ok) {
        throw cartError(chData, 'change');
      }

      renderSections(chData);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upgrade', cartData: chData });
      }
    } catch (err) {
      console.error('[cart-drawer-upgrade] swap failed:', err && err.message, err);
      if (err && err.response) console.error('[cart-drawer-upgrade] server response:', err.response);
      alert(errMsg());
    } finally {
      removeOverlay(contents, overlay);
      btn.disabled = false;
    }
  });
})();
